"use client"

import { useEffect } from "react"
import { useLocation } from "react-router-dom"

interface ScrollToTopProps {
  excludePaths?: string[]
}

export function ScrollToTop({ excludePaths = [] }: ScrollToTopProps) {
  const { pathname } = useLocation()

  useEffect(() => {
    // Check if current path should be excluded
    const shouldExclude = excludePaths.some((path) => pathname.startsWith(path))

    if (!shouldExclude) {
      // Scroll to top smoothly
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      })
    }
  }, [pathname, excludePaths])

  return null
}

